import { encrypt } from '@/utils'
import { get, post } from '@/utils/request'
// import { bcryptEncryption } from 'sky-engine/utils'

export function getUserInfo(projectId) {
  return get('operations/user/getUserInfo', projectId)
}

export function registerUser(params = {}) {
  // const bcryptjs = require('bcryptjs');
  return post('auth/register', {
    phone: params.userPhone.trim(),
    smsVerifyCode: params.userCode.trim(),
    password: encrypt(params.password.trim())
    // passwrod: bcryptEncryption(bcryptjs, params.password)
  })
}

export function verifyPhone(params) {
  return post('auth/checkVerifyCode', {
    phone: params.userPhone.trim(),
    smsVerifyCode: params.userCode.trim()
  })
}

export function editPhone(params = {}) {
  return post('user/account/phone/edit', {
    userId: params.userId,
    newPhone: params.userPhone.trim(),
    verifyCode: params.userCode.trim(),
    password: params.oldPassword.trim(),
    newPassword: params.newPassword.trim()
  })
}

export function editPassword(params = {}) {
  return post('user/modifyUserPassword', {
    oldPassword: encrypt(params.oldPassword.trim()),
    newPassword: encrypt(params.newPassword.trim())
  })
}

export function sendVerifyCode(params) {
  return post('auth/getSmsVerifyCode', {
    phone: params.userPhone.trim(),
    type: params.type
  })
}

export function resetPassword(params) {
  return post('auth/resetPassword', {
    phone: params.userPhone.trim(),
    password: encrypt(params.newPassword.trim()),
    uuid: params.uuid
  })
}

export function addOrg(params) {
  return post('user/addUserInfo', {
    realName: params.realName,
    email: params.email,
    orgName: params.orgName,
    orgType: params.orgType,
    areaId: params.orgArea,
    tradeId: params.orgIndustryId
  })
}

export function joinOrg(params) {
  return post('user/joinOrg', {
    realName: params.realName,
    email: params.email,
    orgSnId: params.orgId
  })
}

export function getAreaInfo(params) {
  return post('user/getAreaInfo', {
    type: params.type,
    parentId: params.parentId
  })
}

export function getOrgInfoById(orgId) {
  return post('user/getOrgInfo', {
    snId: orgId
  })
}

export function checkOrgName(params) {
  return post('org/checkOrgName', {
    orgName: params.name
  })
}

export function modifyRealName(params) {
  return post('user/modifyUserRealName', {
    realName: params.realName
  })
}

export async function checkAdminPwd(pwd) {
  pwd = encrypt(pwd)
  return post(`user/validateUserPwd`, { pwd })
}

export function getMaintenanceState() {
  return post(`user/customerManagement/getMaintainStatus`)
}

export function outMaintenance(id) {
  return post(`user/customerManagement/endMaintain`, { id: ~~id })
}

export function getCheckJoinInfo() {
  return post('user/getCheckJoinInfo')
}

export function cancelCheck() {
  return post('user/cancelCheck')
}

export function outOrg() {
  return post('user/member/org/leave')
}

export function checkOrgDelete() {
  return post('org/checkDelete')
}

export function DeleteOrg({ code, password }) {
  password = encrypt(password)
  return post('org/delete', { pwd: password, smsVerifyCode: code })
}

export function editOrgName(orgName) {
  return post('org/modifyOrgName', {
    orgName
  })
}

export function editOrgArea(areaId) {
  return post('org/modifyOrgArea', {
    areaId
  })
}

export function getIndustryList(parentId = 0) {
  return post('trade/list', { parentId })
}

export function editIndustry(industryId) {
  return post('org/modifyTrade', { tradeId: industryId })
}

export function getAuthType(phone) {
  return post('auth/getAuthType', { phone: phone.trim() })
}

export function getCurrentEnvOrgInfo() {
  return post('org/getCurrentEnvOrgInfo', {})
}

export function adminJoinBeta() {
  return post('deploy/admin/joinBeta')
}
